import axios from "axios";

import { to } from "../../helpers/api";

export const assets = {
  verifyAsset: ({ asset_id }) => {
    return axios.get(to(`claimed-assets/${asset_id}`));
  }
};
